import {
    ADD_APPLEPAY_FAILED,
    ADD_APPLEPAY_LOADING,
    ADD_APPLEPAY_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const addApplePayConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

    switch (action.type) {
        case ADD_APPLEPAY_LOADING:
            return {
                ...state,
                loading: action.loading,
            };
        case ADD_APPLEPAY_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case ADD_APPLEPAY_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




